import React, { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { programs } from "../../../types/program";
import { FaArrowRight } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { programProgressData } from "../../../types/programProgresData";

const ProgramDetail: React.FC = () => {
  const IconArrow = FaArrowRight as React.FC<React.SVGProps<SVGSVGElement>>;
  const { slug } = useParams();
  const program = programs.find((p) => p.slug === slug);
  useEffect(() => {
    if (program) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [slug, program]);

  if (!program) {
    return <Navigate to="/" replace />;
  }

  return (
    <section className="py-24 max-sm:py-12 px-6 ">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900">
            Program <span className="text-red-600">{program.title}</span>
          </h1>
          <p className="mt-4 text-lg text-gray-600">{program.description}</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-3xl pb-8  shadow-sm">
          {program.content.map((text, index) => (
            <p key={index} className="text-gray-700 leading-relaxed text-justify mb-4">
              {text}
            </p>
          ))}

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-10">
            {program.stats.map((item, index) => (
              <div key={index} className="bg-red-50 rounded-2xl p-6 text-center">
                <h3 className="text-3xl font-bold text-red-600">{item.value}</h3>
                <p className="mt-2 text-sm text-gray-600">{item.label}</p>
              </div>
            ))}
          </div>

          {/* PROGRESS PER PROVINSI */}
          {programProgressData[program.slug] && (
            <div className="mt-14">
              <h2 className="text-xl md:text-2xl  font-bold text-gray-800 mb-6">
                Provinsi dengan Tingkat <span className="text-red-600">{program.title}</span> Tertinggi
              </h2>

              <div className="bg-gray-100 rounded-3xl p-8 space-y-5">
                {programProgressData[program.slug].map((item, index) => (
                  <div key={index}>
                    <div className="flex justify-between mb-1">
                      <span className="text-sm font-medium text-gray-700">{item.province}</span>
                      <span className="text-sm text-gray-500">{item.percentage}%</span>
                    </div>

                    <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                      <div className="bg-red-600 h-3 rounded-full transition-all duration-700" style={{ width: `${item.percentage}%` }} />
                    </div>
                  </div>
                ))}
              </div>

              <p className="text-xs text-gray-400 mt-4">*Data estimasi berbasis prioritas program dan wilayah intervensi.</p>
            </div>
          )}

          {/* CTA */}
          <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <p className="text-gray-700 max-w-xl">Mari ambil peran dalam gerakan kemanusiaan ini melalui penggalangan dana yang transparan dan berdampak nyata.</p>
            <div className="md:flex gap-4 items-center">
              <Link
                to="/regioncheck"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 border border-red-600 text-red-600 
                         px-6 py-4 rounded-xl font-semibold
                         hover:bg-red-100 transition
                         shadow-lg hover:shadow-red-200">
                Lihat Region Check
                <IconArrow />
              </Link>

              <Link
                to="https://belaskasih.com/account/campaign/new"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-red-600 text-white
                         px-6 py-4 rounded-xl font-semibold
                         hover:bg-red-700 transition
                         shadow-lg hover:shadow-red-200 max-sm:mt-6">
                Galang Dana Sekarang
                <IconArrow />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramDetail;
